import { ATDLInterfaceControlModel } from "./atdl-interface-control.model";
import { ATDLNOrientation } from "../enums/atdl-orientation.enum";

export class ATDLInterfaceLayoutModel {
  public collapsible: boolean = null;
  public orientation: ATDLNOrientation = null;
  public layouts: Array<ATDLInterfaceLayoutModel> = null;
  public controls: Array<string> = null; // ATDLInterfaceControlModel
}
